var map = {
	"./Admin/Dashboard": [
		9055,
		55
	],
	"./Admin/Dashboard.vue": [
		9055,
		55
	],
	"./Admin/Events/Edit": [
		7029,
		29
	],
	"./Admin/Events/Edit.vue": [
		7029,
		29
	],
	"./Admin/Events/Index": [
		7735,
		735
	],
	"./Admin/Events/Index.vue": [
		7735,
		735
	],
	"./Admin/Login": [
		9912,
		912
	],
	"./Admin/Login.vue": [
		9912,
		912
	],
	"./Admin/News/Edit": [
		223,
		223
	],
	"./Admin/News/Edit.vue": [
		223,
		223
	],
	"./Admin/News/Index": [
		9891,
		891
	],
	"./Admin/News/Index.vue": [
		9891,
		891
	],
	"./Front/AfricaData/AfricaData": [
		3437,
		437
	],
	"./Front/AfricaData/AfricaData.vue": [
		3437,
		437
	],
	"./Front/AfricaData/Gats": [
		7231,
		231
	],
	"./Front/AfricaData/Gats.vue": [
		7231,
		231
	],
	"./Front/AfricaData/Info": [
		7971,
		971
	],
	"./Front/AfricaData/Info.vue": [
		7971,
		971
	],
	"./Front/AfricaData/TopMarkets": [
		4751,
		751
	],
	"./Front/AfricaData/TopMarkets.vue": [
		4751,
		751
	],
	"./Front/CompetitionRules": [
		2823,
		823
	],
	"./Front/CompetitionRules.vue": [
		2823,
		823
	],
	"./Front/Contact": [
		8937,
		937
	],
	"./Front/Contact.vue": [
		8937,
		937
	],
	"./Front/Events/Index": [
		6744,
		744
	],
	"./Front/Events/Index.vue": [
		6744,
		744
	],
	"./Front/Events/Show": [
		1548,
		548
	],
	"./Front/Events/Show.vue": [
		1548,
		548
	],
	"./Front/Home/About": [
		976,
		976
	],
	"./Front/Home/About.vue": [
		976,
		976
	],
	"./Front/Home/Chicken": [
		2330,
		330
	],
	"./Front/Home/Chicken.vue": [
		2330,
		330
	],
	"./Front/Home/History": [
		8003,
		3
	],
	"./Front/Home/History.vue": [
		8003,
		3
	],
	"./Front/Home/Home": [
		3756,
		756
	],
	"./Front/Home/Home.vue": [
		3756,
		756
	],
	"./Front/Home/JoinDatabase": [
		3448,
		448
	],
	"./Front/Home/JoinDatabase.vue": [
		3448,
		448
	],
	"./Front/Home/Quality": [
		3969,
		969
	],
	"./Front/Home/Quality.vue": [
		3969,
		969
	],
	"./Front/Home/Services": [
		3752,
		752
	],
	"./Front/Home/Services.vue": [
		3752,
		752
	],
	"./Front/Home/Turkey": [
		5083,
		83
	],
	"./Front/Home/Turkey.vue": [
		5083,
		83
	],
	"./Front/Member": [
		1412,
		412
	],
	"./Front/Member.vue": [
		1412,
		412
	],
	"./Front/MobileApp": [
		6815,
		815
	],
	"./Front/MobileApp.vue": [
		6815,
		815
	],
	"./Front/News/Index": [
		1473,
		473
	],
	"./Front/News/Index.vue": [
		1473,
		473
	],
	"./Front/News/Show": [
		6962,
		962
	],
	"./Front/News/Show.vue": [
		6962,
		962
	],
	"./Front/PastEvents/Index": [
		5076,
		76
	],
	"./Front/PastEvents/Index.vue": [
		5076,
		76
	],
	"./Front/PastEvents/Show": [
		266,
		266
	],
	"./Front/PastEvents/Show.vue": [
		266,
		266
	],
	"./Front/Privacy": [
		1896,
		896
	],
	"./Front/Privacy.vue": [
		1896,
		896
	],
	"./Front/Safety/Export": [
		8132,
		132
	],
	"./Front/Safety/Export.vue": [
		8132,
		132
	],
	"./Front/Safety/Health": [
		2619,
		619
	],
	"./Front/Safety/Health.vue": [
		2619,
		619
	],
	"./Front/Safety/Poultry": [
		1601,
		601
	],
	"./Front/Safety/Poultry.vue": [
		1601,
		601
	],
	"./Front/Safety/Protein": [
		424,
		424
	],
	"./Front/Safety/Protein.vue": [
		424,
		424
	],
	"./Front/Safety/Recipes": [
		1740,
		740
	],
	"./Front/Safety/Recipes.vue": [
		1740,
		740
	],
	"./Front/Safety/Safety": [
		3713,
		713
	],
	"./Front/Safety/Safety.vue": [
		3713,
		713
	],
	"./Front/Trade/AfricaMarket": [
		3278,
		278
	],
	"./Front/Trade/AfricaMarket.vue": [
		3278,
		278
	],
	"./Front/Trade/BuyersGuide": [
		8637,
		637
	],
	"./Front/Trade/BuyersGuide.vue": [
		8637,
		637
	],
	"./Front/Trade/ChickenClasses": [
		4111,
		111
	],
	"./Front/Trade/ChickenClasses.vue": [
		4111,
		111
	],
	"./Front/Trade/ChickenNutrition": [
		6172,
		172
	],
	"./Front/Trade/ChickenNutrition.vue": [
		6172,
		172
	],
	"./Front/Trade/Faq": [
		1702,
		702
	],
	"./Front/Trade/Faq.vue": [
		1702,
		702
	],
	"./Front/Trade/Fsis": [
		4446,
		446
	],
	"./Front/Trade/Fsis.vue": [
		4446,
		446
	],
	"./Front/Trade/Phis": [
		7078,
		78
	],
	"./Front/Trade/Phis.vue": [
		7078,
		78
	],
	"./Front/Trade/Posters": [
		3365,
		365
	],
	"./Front/Trade/Posters.vue": [
		3365,
		365
	],
	"./Front/Trade/SubmitTrade": [
		6660,
		660
	],
	"./Front/Trade/SubmitTrade.vue": [
		6660,
		660
	],
	"./Front/Trade/Trade": [
		4919,
		919
	],
	"./Front/Trade/Trade.vue": [
		4919,
		919
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4985;
module.exports = webpackAsyncContext;